import React, { Fragment } from "react";
import BannerBottom from "./BannerBottom";
import HomeSlider from "./Banner";
import Services from "./Services";
import LstProjects from "./LstProjects";
import Counter from "./Counter";
import Clients from "./Clients";
import Blog from "./Blog";

const Home = () => {
  return (
    <Fragment>
      <HomeSlider />
      <BannerBottom />
      <Services />
      <LstProjects />
      <Counter />
      <Clients />
      <Blog />
    </Fragment>
  );
};

export default Home;
